import React, { useState, useEffect } from "react";
import ModuleHeader from "../../moduleHeader";
import { getNumerologyData } from "../../../services/numerologyService";
import { getCurrentPackageUserModule } from "../../../services/api";

function Numerology({ id, moduleId, isOwner }) {
  const [numerologyData, setNumerologyData] = useState(null);
  const [packageData, setPackageData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isHeaderExpanded, setIsHeaderExpanded] = useState(false);

  // Paket ve kullanıcı bilgilerini çek (moduleId sabit 4 - Numeroloji)
  useEffect(() => {
    if (!id) return;

    const fetchPackageData = async () => {
      try {
        const data = await getCurrentPackageUserModule(id, 4);
        setPackageData(data);
      } catch (error) {
        console.error("Paket verisi alınamadı:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchPackageData();
  }, [id]);

  // Numeroloji verisini çek
  useEffect(() => {
    const fetchNumerology = async () => {
      try {
        const response = await getNumerologyData();
        setNumerologyData(response.numerology);
      } catch (error) {
        console.error("Numeroloji verisi alınamadı:", error);
      }
    };

    fetchNumerology();
  }, []);

  // Data yapısını kontrol et ve güvenli erişim sağla
  const numerologyDataSafe = numerologyData || {};

  const numerolojiData = [
    {
      id: 1,
      title: "Ruh Güdüsü",
      number: numerologyDataSafe.ruh_gudusu?.sayi || 0,
      subtitle: numerologyDataSafe.ruh_gudusu?.gucler?.join(", ") || "",
      description: numerologyDataSafe.ruh_gudusu?.aciklama || "",
      strengths: numerologyDataSafe.ruh_gudusu?.gucler || [],
      improvements: numerologyDataSafe.ruh_gudusu?.gelistirilecek_yonler || [],
      suggestions: numerologyDataSafe.ruh_gudusu?.oneriler || [],
      bgColor: "bg-gradient-to-br from-purple-50 to-purple-100",
      textColor: "text-purple-800",
      iconColor: "text-purple-600",
      icon: "🌟",
    },
    {
      id: 2,
      title: "İç Güdüsü",
      number: numerologyDataSafe.ic_gudusu?.sayi || 0,
      subtitle: numerologyDataSafe.ic_gudusu?.gucler?.join(", ") || "",
      description: numerologyDataSafe.ic_gudusu?.aciklama || "",
      strengths: numerologyDataSafe.ic_gudusu?.gucler || [],
      improvements: numerologyDataSafe.ic_gudusu?.gelistirilecek_yonler || [],
      suggestions: numerologyDataSafe.ic_gudusu?.oneriler || [],
      bgColor: "bg-gradient-to-br from-green-50 to-green-100",
      textColor: "text-green-800",
      iconColor: "text-green-600",
      icon: "💚",
    },
    {
      id: 3,
      title: "İfade",
      number: numerologyDataSafe.ifade?.sayi || 0,
      subtitle: numerologyDataSafe.ifade?.gucler?.join(", ") || "",
      description: numerologyDataSafe.ifade?.aciklama || "",
      strengths: numerologyDataSafe.ifade?.gucler || [],
      improvements: numerologyDataSafe.ifade?.gelistirilecek_yonler || [],
      suggestions: numerologyDataSafe.ifade?.oneriler || [],
      bgColor: "bg-gradient-to-br from-orange-50 to-orange-100",
      textColor: "text-orange-800",
      iconColor: "text-orange-600",
      icon: "💬",
    },
    {
      id: 4,
      title: "Yaşam Amacı",
      number: numerologyDataSafe.yasam_amaci?.sayi || 0,
      subtitle: numerologyDataSafe.yasam_amaci?.gucler?.join(", ") || "",
      description: numerologyDataSafe.yasam_amaci?.aciklama || "",
      strengths: numerologyDataSafe.yasam_amaci?.gucler || [],
      improvements: numerologyDataSafe.yasam_amaci?.gelistirilecek_yonler || [],
      suggestions: numerologyDataSafe.yasam_amaci?.oneriler || [],
      bgColor: "bg-gradient-to-br from-red-50 to-red-100",
      textColor: "text-red-800",
      iconColor: "text-red-600",
      icon: "🎯",
    },
  ];

  if (loading || !packageData) {
    return (
      <div className="w-full h-screen min-h-screen flex items-center justify-center bg-[#fff]">
        <div className="flex flex-col items-center justify-center">
          <div className="relative mb-8">
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="animate-spin rounded-full h-24 w-24 border-4 border-transparent border-t-[#3DA7B5] border-r-[#3DA7B5] opacity-75"></div>
            </div>
            <div className="absolute inset-0 flex items-center justify-center">
              <div
                className="animate-spin rounded-full h-16 w-16 border-[3px] border-transparent border-b-[#2a8a96] border-l-[#2a8a96] opacity-60"
                style={{
                  animationDirection: "reverse",
                  animationDuration: "1.5s",
                }}
              ></div>
            </div>
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="h-12 w-12 rounded-full bg-gradient-to-br from-[#3DA7B5] via-[#2a8a96] to-[#3DA7B5] animate-pulse shadow-2xl"></div>
            </div>
          </div>
          <p className="text-xl font-semibold text-gray-800 animate-pulse">
            Yükleniyor...
          </p>
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="w-full h-screen min-h-screen flex items-stretch justify-stretch sm:items-center sm:justify-center bg-[#e8e9ed] relative">
        <div className="flex flex-col items-center w-full min-h-full bg-white shadow-xl border border-gray-200 rounded-none sm:max-w-[390px] sm:h-[700px] sm:rounded-3xl relative overflow-y-auto">
          {/* ModuleHeader */}
          {packageData && (
            <div className="relative z-30 w-full mb-5">
              <ModuleHeader
                userName={
                  packageData.user?.first_name +
                  " " +
                  packageData.user?.last_name
                }
                subtitle={packageData.package?.name + " Modülüne Hoş Geldiniz"}
                title={packageData.package?.name}
                description={packageData.package?.description}
                backgroundImage={packageData.package?.image_url}
                onExpandedChange={setIsHeaderExpanded}
                showToggle={true}
                autoHeight={true}
              />
            </div>
          )}

          <div
            className={`relative flex flex-col w-full text-gray-800 bg-transparent rounded-t-3xl z-10 transition-all duration-300 ${
              isHeaderExpanded ? "-mt-8" : "-mt-8"
            }`}
          >
            <div className="bg-white px-4 py-6 mb-32">
              <div className="max-w-sm mx-auto">
                {/* Numeroloji Kartları */}
                <div className="space-y-3">
                  {numerolojiData.map((item, index) => (
                    <div
                      key={item.id}
                      className={`group cursor-pointer ${item.bgColor} rounded-2xl p-5  border border-white/50 hover:border-gray-200/50 transform hover:scale-[1.01] active:scale-[0.99] transition-all duration-200`}
                      style={{
                        animationDelay: `${index * 100}ms`,
                        animation: "fadeInUp 0.4s ease-out forwards",
                      }}
                    >
                      {/* Üst kısım - Başlık ve Sayı */}
                      <div className="flex items-center justify-between mb-3">
                        <div className="flex items-center space-x-3">
                          <div>
                            <h3
                              className={`text-base font-bold ${item.textColor}`}
                            >
                              {item.title}
                            </h3>
                          </div>
                        </div>
                        <div className="w-7 h-7 bg-white/70 rounded-full flex items-center justify-center">
                          <span
                            className={`text-sm font-bold ${item.iconColor}`}
                          >
                            {item.number}
                          </span>
                        </div>
                      </div>

                      {/* Alt kısım - Güçler ve Açıklama */}
                      {item.strengths && item.strengths.length > 0 && (
                        <div className="mb-3">
                          <div className="flex flex-wrap gap-1">
                            {item.strengths.map((strength, idx) => (
                              <div
                                key={idx}
                                className="inline-flex items-center px-2 py-1 bg-white/50 rounded-lg"
                              >
                                <span
                                  className={`text-xs font-medium ${item.iconColor}`}
                                >
                                  {strength}
                                </span>
                              </div>
                            ))}
                          </div>
                        </div>
                      )}

                      <div className="bg-white/50 rounded-xl p-3 space-y-2">
                        <p
                          className={`text-xs leading-relaxed ${item.textColor} text-left`}
                        >
                          {item.description}
                        </p>

                        {/* Geliştirilecek Yönler */}
                        {item.improvements && item.improvements.length > 0 && (
                          <div className="pt-2 border-t border-white/30 text-left">
                            <p
                              className={`text-xs font-medium ${item.iconColor} mb-1 text-left`}
                            >
                              Geliştirilecek Yönler:
                            </p>
                            <p
                              className={`text-xs ${item.textColor} text-left`}
                            >
                              {item.improvements.join(", ")}
                            </p>
                          </div>
                        )}

                        {/* Öneriler */}
                        {item.suggestions && item.suggestions.length > 0 && (
                          <div className="pt-2 border-t border-white/30 text-left">
                            <p
                              className={`text-xs font-medium ${item.iconColor} mb-1 text-left`}
                            >
                              Öneriler:
                            </p>
                            <ul
                              className={`text-xs ${item.textColor} space-y-1 text-left`}
                            >
                              {item.suggestions.map((suggestion, idx) => (
                                <li
                                  key={idx}
                                  className="flex items-start text-left"
                                >
                                  <span className="mr-1">•</span>
                                  <span className="text-left">
                                    {suggestion}
                                  </span>
                                </li>
                              ))}
                            </ul>
                          </div>
                        )}
                      </div>
                    </div>
                  ))}
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(15px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </>
  );
}

export default Numerology;
